import React from "react";
import { connect } from "react-redux";
import { FullSemisterTopForm } from "../../components/FullSemisterTopForm";
import FullTopSmister from "../../components/FullTopSmister/FullTopSmister";
import PublicLayout from "../../components/shared/PublicLayout/PublicLayout";
const PublicMeritListPage = ({ data }) => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <PublicLayout title="Final Merit List">
        <FullSemisterTopForm />
        {data ? <FullTopSmister data={data} /> : <></>}
      </PublicLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.mark.full_semister_top,
});

export default connect(mapStateToProps, null)(PublicMeritListPage);
